import { GET_LANGS, GET_LANGS_SUCCESS, GET_LANGS_ERROR } from "../actions";

const INIT_STATE = {
  langs: [{ nativeName: "Türkçe", code: "tr", default: true }],
  loading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LANGS:
      return Object.assign({}, state, {
        loading: true,
      });
    case GET_LANGS_SUCCESS:
      return Object.assign({}, state, {
        langs: action.payload,
        loading: false,
      });
    case GET_LANGS_ERROR:
      return Object.assign({}, state, {
        loading: false,
      });
    default:
      return { ...state };
  }
};
